import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PRODUCTS, STAFF_ROLE_LABELS } from '@traceio-org/platform-contracts';
import { TRACE_MARK } from '../brand/lockups.js';
import { ChevronIcon } from './icons.js';
import { OrganizationMark } from './OrganizationMark.js';
function joinNames(names) {
    if (names.length <= 1)
        return names[0] ?? '';
    return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
/** Products the person can open from the workspace, now or after the organization's own sign-in. */
function availableProducts(context) {
    const names = context.products
        .filter((p) => p.state === 'available' || p.state === 'sso_required')
        .map((p) => PRODUCTS[p.productKey].shortName);
    return names.length > 0 ? joinNames(names) : 'No products available yet';
}
export function describeWorkspace(context) {
    switch (context.type) {
        case 'employee':
            return {
                name: context.organization.displayName,
                kind: 'Employee workspace',
                detail: availableProducts(context),
                suspended: context.organization.status === 'suspended',
                ssoRequired: context.products.some((p) => p.state === 'sso_required'),
            };
        case 'portal':
            return {
                name: context.customerAccount.displayName,
                kind: 'Customer portal',
                detail: context.portal.displayName,
                suspended: context.providerOrganization.status === 'suspended',
                ssoRequired: false,
            };
        case 'staff':
            return {
                name: 'Trace staff',
                kind: 'Staff access',
                detail: STAFF_ROLE_LABELS[context.staffRole],
                suspended: false,
                ssoRequired: false,
            };
    }
}
function ContextMark({ context, assetBaseUrl }) {
    if (context.type === 'staff') {
        return (_jsx("span", { className: "trace-auth-orgmark trace-auth-orgmark--logo trace-auth-orgmark--trace", children: _jsx("img", { src: TRACE_MARK.obsidian.url, alt: "", width: "24", height: "24" }) }));
    }
    const branding = context.type === 'employee' ? context.organization.branding : context.providerOrganization.branding;
    return _jsx(OrganizationMark, { branding: branding, assetBaseUrl: assetBaseUrl, variant: "compact" });
}
/** The workspaces (employee, customer portal and staff contexts) a signed-in person can enter. */
export function WorkspaceList({ contexts, onSelect, busyId = null, assetBaseUrl, label = 'Workspaces' }) {
    return (_jsx("ul", { className: "trace-auth-choices", "aria-label": label, children: contexts.map((context) => {
            const description = describeWorkspace(context);
            return (_jsx("li", { children: _jsxs("button", { type: "button", className: "trace-auth-choice", onClick: () => void onSelect(context.id), disabled: busyId !== null, "aria-busy": busyId === context.id || undefined, "data-context-type": context.type, children: [_jsx("span", { className: "trace-auth-choice__mark", "aria-hidden": "true", children: _jsx(ContextMark, { context: context, assetBaseUrl: assetBaseUrl }) }), _jsxs("span", { className: "trace-auth-choice__text", children: [_jsx("span", { className: "trace-auth-choice__name", children: description.name }), _jsxs("span", { className: "trace-auth-choice__meta", children: [description.kind, _jsx("span", { "aria-hidden": "true", children: " \u00B7 " }), description.detail] }), description.suspended ? _jsx("span", { className: "trace-auth-choice__state", children: "Suspended" }) : null, description.ssoRequired && !description.suspended ? (_jsx("span", { className: "trace-auth-choice__state", children: "Requires your organization's sign-in" })) : null] }), _jsx(ChevronIcon, {})] }) }, context.id));
        }) }));
}
//# sourceMappingURL=WorkspaceList.js.map